<template>
    <router-view/>
</template>

<script>
export default {
    name: "RootView"
}
</script>

<style scoped>

</style>
